import type { ErrorEvent } from '@sentry/react';

export function isGeneralError(e: unknown): e is Error {
  return e instanceof Error;
}

export function isDynamicFetchModuleError(err: unknown) {
  return (
    err instanceof TypeError &&
    err.message.startsWith('Failed to fetch dynamically imported module:')
  );
}

export function isPreloadCssError(err: unknown) {
  return (
    err instanceof Error && err.message.startsWith('Unable to preload CSS for')
  );
}

export function isAppRenewChunkLossError(err: unknown) {
  return [isDynamicFetchModuleError, isPreloadCssError].some(assert =>
    assert(err)
  );
}

export function isChromeExtensionError(sentryEvent: ErrorEvent) {
  // Ignore error emitted from chrome extension
  if (
    sentryEvent.exception &&
    sentryEvent.exception.values &&
    sentryEvent.exception.values[0]?.stacktrace
  ) {
    const stacktrace = sentryEvent.exception.values[0].stacktrace;
    if (
      stacktrace.frames?.some(frame =>
        frame.filename?.includes('chrome-extension://')
      )
    ) {
      return true;
    }
  }
  return false;
}
